import { SyntheticEvent } from 'react';

import { openInNewTab } from '@/helpers';
import { enUpsellTypeProduct, IShowcaseBannerUpsell, IUpsell, IUTM } from '@/interfaces/upsell';

import { useAppSelector } from './redux';

declare let EduzzWidget: any;

export const useCheckout = (upsell: IUpsell | IShowcaseBannerUpsell, utm: IUTM) => {
  const user = useAppSelector(store => store.auth.user);

  const baseSearchParams = {
    utm_source: 'NUTROR',
    utm_campaign: 'C1C',
    utm_content: upsell.id,
    TRK1: 'NUTROR',
    TRK2: 'C1C',
    TRK3: upsell.id,
    email: (!!user?.email && user.email.trim()) || '',
    nome: (!!user?.name && user.name.trim()) || '',
    ...utm
  };

  const toSearchParams = (params: Record<string, string | number>) => {
    return Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
  };

  const openSunTicket = () => {
    return openInNewTab(
      `https://sun.eduzz.com/${upsell.content}?${toSearchParams({
        ...baseSearchParams,
        utm_campaign: 'TICKET',
        TRK2: 'TICKET'
      })}`
    );
  };

  const openSunServices = () => {
    return openInNewTab(
      `https://cs.eduzz.com/${upsell.content}/${toSearchParams({
        ...baseSearchParams,
        utm_campaign: 'SERVICO',
        TRK2: 'SERVICO'
      })}`
    );
  };
  const openSunWidget = (event: SyntheticEvent) => {
    EduzzWidget(
      'Widget',
      {
        id: upsell.content,
        qs: baseSearchParams
      },
      event.target
    );
    (window as any).Edz.Initiate();
  };

  return (event: SyntheticEvent) => {
    const mapper: Record<number, (event: SyntheticEvent) => void> = {
      [enUpsellTypeProduct.ticket]: openSunTicket,
      [enUpsellTypeProduct.services]: openSunServices
    };

    return (mapper[upsell.type] ?? openSunWidget)(event);
  };
};
